import React from 'react'
import { styled, SelectChangeEvent, Grid } from '@mui/material'
import { translate } from '../../../../../i18n'
import { GContainer } from '../../grids'
import { SelectNoBind } from '../../inputs/selectNoBind'
import { AttentionLabel } from '../../attentionLabel'
import { PageState } from '../../../../../containers/facilityReservationSelection/facilityReservationSelectionService'
import { TextBox } from '../../inputs/textBox'

const ChildSelectionGContainer = styled(GContainer)({
  marginBottom: '8px',
})

interface diagonosisSelectionProps {
  diagonosisDecodeMst: { value: string; label: string }[]
  changeDropDownSelectedDiagonosis: (event: SelectChangeEvent<string>) => void
  state: PageState
  name: string
  showOtherFlag: boolean
  isrequired: boolean
  isSelectable?: boolean
}
const DiagonosisSelection: React.FC<diagonosisSelectionProps> = (
  { diagonosisDecodeMst, changeDropDownSelectedDiagonosis, name, state, showOtherFlag, isrequired }
) => {
  const value = state.diagonosis[name as keyof typeof state.diagonosis];

  return (
    <ChildSelectionGContainer>
      <div>
        {translate(`facilityReservationSelection.label.diagonosis.${name}`)}
        {
          isrequired && (
            <AttentionLabel>*</AttentionLabel>
          )
        }
      </div>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <SelectNoBind
            fullWidth
            name={`diagonosis.${name}.select`}
            onChange={changeDropDownSelectedDiagonosis}
            valueLabels={diagonosisDecodeMst}
            value={value ?? undefined}
          />
        </Grid>
        {
          showOtherFlag === true && (
            <Grid item xs={12}>
              <TextBox name={`diagonosis.${name}.other`} label="詳細" maxLength={100} multiline rows={4} required />
            </Grid>
          )
        }
      </Grid>
    </ChildSelectionGContainer>
  )
}

export default DiagonosisSelection